















































































































































import { Component, Vue } from 'nuxt-property-decorator';
import { FreeTrialButton } from '~/components';

@Component({
  components: {
    FreeTrialButton
  }
})
export default class AccessPage extends Vue {
  maplocation: any = {
    lat: 33.228852022210595,
    lng: 131.61579372169342
  };

  zoom: number = 14;

  mapOptions: any = {
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false,
    styles: []
  }

  markers: any = [
    {
      title: 'YouSpeak',
      position: {
        lat: 33.22885202221059,
        lng: 131.61579372169342
      },
    },
  ];

  infoWindowOptions: any = {
    pixelOffset: {
      width: 0,
      height: -35
    }
  };

  onClickMarker () {

  }
}
